<!--
  기업 정보 컴포넌트
-->
<template>
  <section
    class="section_home counter"
    data-effect-slide="scroll"
  >
    <div v-if="isVisible" class="inner" v-html="mktngCntnt" />
  </section>
</template>

<script>
import { isEmpty } from 'lodash'
import commonMixin from '@/mixin/commonMixin'
import MotionEffects from '/src/assets/js/MotionEffects'

export default {
  name: 'CompanyInfo',
  components: {

  },
  mixins: [commonMixin, MotionEffects],
  props: {
    potltInfo: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  computed: {
    mktngCntnt () {
      let homeInfoStore = window.vue.getStore('homeInfo')
      let mobileInfo = homeInfoStore.getters.mobileInfo
      return mobileInfo.mktngCntnt // 기업정보 HTML
    }
  },
  created () {
    this.isVisible = !isEmpty(this.mktngCntnt)
  }
}
</script>

<style>
/* css 적용 안되어 추가함 */
section.section_home.counter > .inner {
  & .counter_bottom {
      z-index: 1;
    & ul {
      li:first-child {
        padding-right: 34px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompanyInfo.vue